var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:('background-color:'+_vm.inlineStyles.colors.main)},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('h1',[_vm._v("Page Not Found")]),_c('v-btn',{attrs:{"color":_vm.inlineStyles.colors.secondary,"outlined":""},on:{"click":function($event){return _vm.goToMain()}}},[_vm._v(" Go To Home ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }